import sortBy from 'lodash/sortBy'
import type {SubjectT} from '@freckle/educator-entities/ts/common/helpers/subjects'
import type {fancyOperations, FancyOk} from '@freckle/educator-entities/ts/openapi-clients'
import {fancyClient, extractData, ensureOk} from '@freckle/educator-entities/ts/openapi-clients'

export type CourseAttrs = FancyOk<fancyOperations['getCoursesR']>[0]

export const patchHideCourse = (courseId: number, hidden: boolean): Promise<void> =>
  fancyClient
    .PATCH('/2/courses/{CourseR-CourseId}', {
      params: {path: {'CourseR-CourseId': courseId}},
      body: {hidden}
    })
    .then(ensureOk)

export const isCourseActive = (course: Pick<CourseAttrs, 'archived' | 'hidden'>): boolean =>
  !isCourseHidden(course) && !isCourseArchived(course)

export const isCourseHidden = (course: Pick<CourseAttrs, 'hidden'>): boolean => course.hidden

export const isCourseArchived = (course: Pick<CourseAttrs, 'archived'>): boolean => course.archived

export const doesCourseHaveSisId = (course: Pick<CourseAttrs, 'sisId'>): boolean =>
  course.sisId !== null

export const fetchCourses = (): Promise<Array<CourseAttrs>> =>
  fancyClient
    .GET('/2/courses')
    .then(extractData)
    .then(courses => sortBy(courses, course => course.id))

export const fetchCoursesWithSubject = (subject: SubjectT): Promise<Array<CourseAttrs>> =>
  fancyClient
    .GET('/2/courses', {params: {query: {subject}}})
    .then(extractData)
    .then(courses => sortBy(courses, course => course.id))

export const fetchSchoolCourses = (schoolId: number): Promise<Array<CourseAttrs>> =>
  fancyClient
    .GET('/2/schools/{SchoolP-SchoolId}/courses', {params: {path: {'SchoolP-SchoolId': schoolId}}})
    .then(extractData)
    .then(courses => sortBy(courses, course => course.id))

export type PatchParams = NonNullable<
  fancyOperations['patchCourseR']['requestBody']
>['content']['application/json']

export const patchCourse = (courseId: number, params: PatchParams): Promise<CourseAttrs> =>
  fancyClient
    .PATCH('/2/courses/{CourseR-CourseId}', {
      params: {path: {'CourseR-CourseId': courseId}},
      body: params
    })
    .then(extractData)

export const deleteCourse = (courseId: number) =>
  fancyClient.DELETE('/2/courses/{CourseR-CourseId}', {
    params: {path: {'CourseR-CourseId': courseId}}
  })
